import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle13() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article13" headerImage="lamp.jpg" photographer=" Pixabay" />
        <Footer />
    </div>
  )
}
